import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import axios from "axios";

export class Newsletter extends React.Component {
	constructor(props) {
		super(props);

		let showIcon = localStorage.getItem("removeNewsletterIcon");
		if (showIcon === null) {
			showIcon = sessionStorage.getItem("removeNewsletterIcon") ? false : true;
		} else {
			showIcon = false;
		}

		this.state = {
			showModal: false,
			showIcon,
			nombre: "",
			email: "",
			feedback: {
				status: "",
				message: ""
			}
		};
		this.handleSubmit = this.handleSubmit.bind(this);
		this.toggleModal = this.toggleModal.bind(this);
		this.hideIcon = this.hideIcon.bind(this);
		this.InputChange = this.InputChange.bind(this);
	}
	handleSubmit(e) {
		e.preventDefault();
		const { nombre, email } = this.state;
		if (nombre === "" || email === "") {
			return;
		}
		axios
			.post(this.props.subscribeApi, {
				nombre,
				email
			})
			.then(() => {
				localStorage.setItem("removeNewsletterIcon", true);
				this.setState({
					feedback: {
						status: "success",
						message: this.props.translate.newsletter_subscribed
					}
				});
				setTimeout(() => {
					this.hideIcon();
				}, 4000);
			})
			.catch(req => {
				const { statusText } = req;
				console.log(req);
				this.setState({
					feedback: {
						status: "error",
						message:
							"Error: " + statusText ? statusText : "Intentalo nuevamente"
					}
				});
			});
	}
	toggleModal() {
		this.setState({
			showModal: !this.state.showModal
		});
	}
	hideIcon() {
		sessionStorage.setItem("removeNewsletterIcon", true);
		this.setState({
			showIcon: false
		});
	}
	InputChange(e) {
		this.setState({
			[e.target.name]: e.target.value
		});
	}
	render() {
		const { translate, isChrome, host } = this.props;
		if (!this.state.showIcon || !isChrome) {
			return "";
		}

		let extensionUrl =
			"https://chrome.google.com/webstore/detail/juegosjuegos/fdkgolkkimdnnjaeiogdciekaflaellb";
		if (host.includes("jogosjogos")) {
			extensionUrl =
				"https://chrome.google.com/webstore/detail/jogosjogos/plhdffccclnkdlolokgfdobocldbjdjn";
		} else if (host.includes("pomu")) {
			extensionUrl =
				"https://chrome.google.com/webstore/detail/pomu/njbfimohacanhjdokmpagpaaadkkmhkh";
		}
		return (
			<div className="Newsletter">
				{this.state.showModal ? (
					<div className="Newsletter-form">
						<button
							className="Newsletter-form-close"
							type="button"
							onClick={this.hideIcon}
						>
							<i className="fa fa-times" />
						</button>
						<div className="in-line">
							<p>{translate.install_extension_popup_text}</p>
							<div className="s_plugin_icon"></div>
						</div>

						<a
							href={extensionUrl}
							className="btn btn-activar chrome"
							target="_blank"
						>
							<i className="fa fa-chrome" />{" "}
							{translate.install_extension_button}
						</a>
					</div>
				) : null}
				<button onClick={this.toggleModal}>
					<span
						className="s_pomu_megafono"
						aria-label={translate.subscribirse}
					/>
				</button>
			</div>
		);
	}
}
Newsletter.propTypes = {
	translate: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
	isChrome: PropTypes.bool.isRequired,
	host: PropTypes.string.isRequired
};
Newsletter.defaultProps = {
	translate: {
		placeholder_nombre: "Nombre",
		placeholder_email: "Email",
		subscribirse: "Subscribirse",
		newsletter_title: "¡ Juegos nuevos en tu Email !",
		newsletter_body:
			"Recibe cada sábado en tu email los mejores juegos de la semana y las últimas novedades",
		newsletter_subscribed: "Te haz registrado en el newsletter correctamente"
	},
	subscribeApi: "/api/subscribe"
};
export default Newsletter;
